import dayjs from "dayjs";


export default function ViewTransactionsDayOptions() {
  return [
    {
      label: "N/A",
      value: null,
    },
    {
      label: "1day",
      value: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(1, "day").endOf("day").toDate(),
      },
    },
    {
      label: "3days",
      value: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(3, "day").endOf("day").toDate(),
      },
    },
    {
      label: "7days",
      value: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(7, "day").endOf("day").toDate(),
      },
    },
    {
      label: "14days",
      value: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(14, "day").endOf("day").toDate(),
      },
    },
    {
      label: "30days",
      value: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().add(30, "day").endOf("day").toDate(),
      },
    },
  ];
}